import { render, staticRenderFns } from "./AbsencesTable.vue?vue&type=template&id=1a1accf2&"
import script from "./AbsencesTable.vue?vue&type=script&lang=js&"
export * from "./AbsencesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports